<template>
    <div class="flex h-full items-center justify-end ">
        <div v-if="showDeleteConfirmation" class="flex items-center">
            <UButton
                data-cy="confirm-delete-transaction"
                size="xs"
                color="error"
                class="mr-1"
                @click.stop="handleDelete"
            >
                Slett?
            </UButton>
            <UButton
                icon="i-ph-x"
                color="neutral"
                variant="subtle"
                size="xs"
                @click.stop="showDeleteConfirmation = false"
            />
        </div>
        <div v-else class="flex items-center">
            <button
                title="Hent kladd"
                class="text-lg i-ph:arrow-up hover:text-primary"
                data-cy="select-draft-button"
                @click.stop="handleRetrieve"
            />
            <button
                title="Slett kladd"
                class="text-lg i-ph-trash-fill hover:text-primary"
                data-cy="delete-draft-button"
                @click.stop="showDeleteConfirmation = true"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'

const props = defineProps({
    params: {
        type: Object as () => {
            deleteSingleDraft: () => Promise<any>,
            applyDraftToTransactionLine: () => void,
        },
        required: true
    }
})

const showDeleteConfirmation = ref(false)

const handleDelete = async () => await props.params.deleteSingleDraft()

const handleRetrieve = () => props.params.applyDraftToTransactionLine()

</script>

<style scoped>

</style>